export default {"src":"/_next/static/media/linkedin2.bb436986.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};